import React, { useState, useEffect } from "react";
import Carousel from "react-spring-3d-carousel";
import { config } from "react-spring";
import greenDrop from "../../img/green_drop.svg";
import greenEnergy from "../../img/green_energy.svg";
import co2Colored from "../../img/co2Colored.png";
import green_chimicals from "../../img/green_chimicals.svg";
import LazyImg from "../Library/LazyImage";
import "./Carousel3D.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import axiosInstance from "../../config/axios-instance";

interface Carousel3DProps {
  width: number;
  commitmentData: any;
  threeData: any[];
}

function Carousel3D({ width, commitmentData, threeData = [] }: Carousel3DProps) {
  // useState hooks
  const [goToSlide, setGoToSlide] = useState(0);
  const [offsetRadius] = useState(2);
  const [showNavigation] = useState(false);
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    // Set the timer for auto-advancing the slides
    const timer = setInterval(() => {
      if (!hovered && threeData?.length) {
        setGoToSlide(prevSlide => (prevSlide + 1) % threeData.length);
      }
    }, 4000);

    // Clean up the timer when the component unmounts
    return () => clearInterval(timer);
  }, [hovered, threeData]);

  // Map 'threeData' to generate the slides
  const slides = threeData?.map((content:any, index:any) => ({
    key: content.id, // Assuming each content has a unique 'id'
    content: (
        <div className="carousel_item">
          <LazyImg src={process.env.REACT_APP_STORAGE_URL+content.image} alt={content.description} />
          <p>{content.description}</p>
        </div>
    ),
    onClick: () => setGoToSlide(index),
  }));

  return (
      <div className="sustainabiliy">
        {width <= 768 && <div className="blue_line"></div>}
        <h1 className="our_label text-center">
          {commitmentData?.title_1}
        </h1>
        <p className="sustainability_paragraph">
          {commitmentData?.description_1}
        </p>
        <p className="sustainability_paragraph">
          {commitmentData?.description_1}
        </p>

        <div
            className="carousel3D_wrapper"
            onMouseOver={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
          <Carousel
              slides={slides}
              goToSlide={goToSlide}
              offsetRadius={offsetRadius}
              showNavigation={showNavigation}
              animationConfig={config.gentle}
          />
        </div>

        {/* Icons navigation conditional rendering */}
      </div>
  );
}

export default Carousel3D;

